import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Row,
  Col,
  Card,
  Image,
  Table,
  Modal,
  Container,
  Form as forms,
} from "react-bootstrap";
// import "../Common/Common.css";
import { Formik, Form } from "formik";
import { TextArea } from "../../Common/FormikTemplates/TextArea";
import { TextField } from "../../Common/FormikTemplates/TextField";
import { DropDown } from "../../Common/FormikTemplates/DropDown";
import { Multiselect } from "multiselect-react-dropdown";
import MapLocation from "../Components/MapLocation";
import * as Yup from "yup";
import moment from "moment";
import InputGroup from "react-bootstrap/InputGroup";
import { Link } from "react-router-dom";

var dateFormat = require("dateformat");

const PersonalDetails = ({ clickHandler, ...props }) => {
  const [callingCodeName, setcallingCodeNameName] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [setGeo, setSelectedGeo] = useState([]);
  const [shipperprofImage, setshipperprofImage] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    props.fetchCountry();
  }, []);

  const handleViewModel = (item) => {
    setShowViewModal(true);
  };
  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const setlocationHandler = (locationData) => {
    setSelectedLocation(locationData.addr);
    setSelectedGeo(locationData.geo);

    ref.current.values.addr = locationData.addr;
    ref.current.values.geo = locationData.geo;
    setShowViewModal(false);
  };

  let user = JSON.parse(localStorage.getItem("user"));

  const handleSelectCountry = (e, formik) => {
    let countryList = props.countryprofdetailList;
    let id = e.target.value || "";
    formik.values.cntry = id;
    ref.current.values.cntry = formik.values.cntry;
    formik.values.region = "";
    formik.values.location = "";
    if (id) {
      formik.errors.cntry && delete formik.errors.cntry;
    }
    props.fetchregion({ countryId: id || null });
    let selectedCountry = countryList.filter((x) => x.countryId.id === id);

    formik.values.callingCode =
      (selectedCountry.length && selectedCountry[0].countryId.callingCode) ||
      "";
    formik.values.crncyCode =
      (selectedCountry.length && selectedCountry[0].currencyId.iso4217Code) ||
      "";
    formik.values.currencyCode =
      (selectedCountry.length && selectedCountry[0].currencyId.id) || "";
    setcallingCodeNameName(
      selectedCountry.length && selectedCountry[0].countryId.callingCode
    );

    // let countryList = props.countrydetailList;
    // let id = e.target.value || "";
    // formik.values.cntry = id;
    // formik.values.region = "";
    // formik.values.location = "";
    // if (id) {
    //   formik.errors.cntry && delete formik.errors.cntry;
    // }
    // props.fetchregion({ countryId: id || null });
    // let selectedCountry = id!==""&&countryList.filter((x) => x.id === id);
    // setcallingCodeNameName(
    //   selectedCountry.length && selectedCountry[0].callingCode
    // );
    // formik.values.crncyCode =
    // (selectedCountry.length && selectedCountry[0].iso3Name) || "";

    // ref.current.values.callingCode = selectedCountry.length&&selectedCountry[0].callingCode;
  };

  const handleSelectregion = (e) => {
    let id = e.target.value || "";
    props.fetchlocation({ regionId: id || null });
  };

  function handleFileChange(e, formik) {
    let fileSize = e.target.files[0].size;
    let ext = e.target.files[0].name.split(".").pop();
    formik.errors.file && delete formik.errors.file;

    formik.values.file = e.target.files[0];
    formik.values.uri = URL.createObjectURL(e.target.files[0]);
    setshipperprofImage(e.target.files[0]);
  }

  const validate = Yup.object({
    cntry: Yup.string().required("Country is required"),
    addr: Yup.string().required("Address is required"),
  });

  console.log("==================user", user);
  console.log("==================props.item", props.item);

  return (
    <div className="driverdetsilsdiv">
      <Formik
        innerRef={ref}
        initialValues={{
          name: (user && user.name) || "",
          // cntry: (user && user.country) || "",
          LName: (user && user.lName) || "",
          // callingCode: (user && user.callingCode) || "",
          mobileNo: (user && user.mobileNo) || "",
          cntry: (props.item && props.item.cntry) || "",
          region: (props.item && props.item.region) || "",
          location: (props.item && props.item.location) || "",
          city: (props.item && props.item.city) || "",
          landmark: (props.item && props.item.landmark) || "",
          zip: (props.item && props.item.zip) || "",
          crncyCode: (props.item && props.item.crncyCode) || "",
          addr: (props.item && props.item.addr) || "",
          file: (props.item && props.item.file) || "",
          uri: "",
          curncyCode: (user && user.curncyCode) || "",
          // callingCode: "",
        }}
        validationSchema={validate}
        onSubmit={(value) => {
          clickHandler(1, value);
        }}
      >
        {(formik) => (
          <div>
            <div>
              <div className="userModalDiv">
                <Form>
                  <div>
                    <p className="shipperhd">Personal Details</p>
                  </div>
                  <Row>
                    <Col lg={10} md={10} sm={12} xs={12}>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <DropDown
                            label="Country"
                            name="cntry"
                            defValue="--Select--"
                            // data={props.countrydetailList}
                            data={
                              props.countryprofdetailList &&
                              props.countryprofdetailList.map((x) => ({
                                ...x,
                                name: x.countryId.name,
                                id: x.countryId.id,
                              }))
                            }
                            onChange={(e) => {
                              handleSelectCountry(e, formik);
                            }}
                            isRequired={true}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <DropDown
                            label="Region"
                            name="region"
                            defValue="--Select--"
                            data={props.regionList}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleSelectregion(e);
                            }}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <DropDown
                            label="Location"
                            name="location"
                            defValue="--Select--"
                            data={props.locationList}
                          />
                        </Col>
                      </Row>
                      {/* <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField
                            label="First Name"
                            name="name"
                            type="text"
                            isRequired={true}
                            readOnly={true}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField
                            label="Last Name"
                            name="LName"
                            type="text"
                            isRequired={true}
                            readOnly={true}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <div className="shiperproftextbox">
                            <TextField
                              label="Mobile Number"
                              name="callingCode"
                              type="text"
                              value={callingCodeName}
                              readOnly={true}
                              isRequired={true}
                            />
                          </div>

                          <div className="shiperproftextbox1">
                            <TextField name="mobileNo" type="text" readOnly={true} />
                          </div>
                        </Col>
                      </Row> */}

                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField
                            label="Address"
                            name="addr"
                            type="text"
                            isRequired={true}
                            // value={selectedLocation}
                            onClick={() => handleViewModel({})}
                            onChange={() => handleViewModel({})}
                          />
                          <MapLocation
                            showViewModal={showViewModal}
                            closeViewModal={closeViewModal}
                            setlocationHandler={setlocationHandler}
                            // item={props.item}
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField label="City" name="city" type="text" />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextArea
                            label="Landmark"
                            name="landmark"
                            type="text"
                            rows="1"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField label="Zip" name="zip" type="text" />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <TextField
                            label="Currency Code"
                            name="crncyCode"
                            type="text"
                            readOnly={true}
                            disabled
                          />
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}></Col>
                      </Row>
                    </Col>
                    <Col lg={2} md={2} sm={12} xs={12}>
                      <Image
                        className="prof-img"
                        src={
                          formik && formik.values && formik.values.file !== ""
                            ? typeof formik.values.file === "string"
                              ? formik.values.file
                              : URL.createObjectURL(formik.values.file)
                            : require("../../../assets/img/img.png")
                        }
                      />

                      <forms.File
                        style={{
                          marginTop: "10px",
                          marginLeft: "76px",
                          width: "90px",
                        }}
                        id="exampleFormControlFile1"
                        type="file"
                        name="file"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => {
                          handleFileChange(e, formik);
                        }}
                      />
                    </Col>
                  </Row>

                  <hr />
                  <button className="btn btn-danger Modalbutton" type="submit">
                    NEXT
                  </button>
                </Form>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default PersonalDetails;
